import cn from 'clsx';
import React from 'react';

import { Button, Heading1, useDeviceType } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/common';
import { ETestIds } from 'shared/constants/testIds';
import { useFillApplicationButtonClick } from 'shared/containers/stickyButtons/FillApplicationButton/hooks/useFillApplicationButtonClick';
import { FeatureHighlightList, IFeatureHighlightItem } from '../FeatureHighlightList';

import {
  IconCommunicationConsultant16,
  IconFinanceSale16,
  IconFunctionalClock24,
  IconProductTrust24,
} from '@cian/ui-kit-design-tokens/icons';
import styles from './styles.css';

const ADVANTAGES: IFeatureHighlightItem[] = [
  {
    title: 'Выгодные\nусловия',
    description: `Покажем предложения, подходящие именно вам`,
    bullet: <IconFinanceSale16 color="icon-main-default" />,
  },
  {
    title: 'Высокий шанс\nодобрения',
    description: `Подскажем, как${NBSP}улучшить заявку, чтобы её${NBSP}одобрили`,
    bullet: <IconProductTrust24 color="icon-main-default" />,
  },
  {
    title: 'Быстрый\nответ',
    description: `Как${NBSP}узнаем ответ от${NBSP}банка${NBSP}— позвоним или${NBSP}пришлём смс`,
    bullet: <IconFunctionalClock24 color="icon-main-default" />,
  },
  {
    title: 'Личный\nменеджер',
    description: 'Всегда на связи и готов помочь',
    bullet: <IconCommunicationConsultant16 color="icon-main-default" />,
  },
];

export const AdvantagesBlock: React.FC = () => {
  const deviceType = useDeviceType();
  const handleCtaClick = useFillApplicationButtonClick();

  return (
    <div className={cn(styles['root'], styles[deviceType])} data-testid={ETestIds.AdvantagesBlock}>
      <div className={cn(styles['title'], styles[deviceType])}>
        <Heading1 fontWeight="700">{`Преимущества ипотеки${NBSP}на${NBSP}Циане`}</Heading1>
      </div>
      <FeatureHighlightList items={ADVANTAGES} bulletSurface="main" />
      <div className={cn(styles['cta'])}>
        <Button fullWidth={deviceType === 'phone'} size="L" onClick={handleCtaClick}>
          Заполнить анкету на Циане
        </Button>
      </div>
    </div>
  );
};
